import {useEffect, useState} from 'react';
import {makeStyles} from "@material-ui/core";
import {getHubs, moveNextPage, updateUserMetrics} from "../../../../../store/actions/creator/creatorExperienceBuilder";
import {useDispatch, useSelector} from "react-redux";
import clsx from 'clsx';
import UtilService from "../../../../../helper/service";
import {useHistory, useLocation} from "react-router";

const useStyles = makeStyles(() => ({
  square: {
    width: 103,
    height: 103,
    borderRadius: 16,
    background: '#F0F0F0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 18,
    marginLeft: 18,
    '&:hover': {
      cursor: 'pointer',
      background: '#FFCE7B',
    }
  },
  icon: {
    width: 80,
    height: 80,
  },
  tinyTitle: {
    color: '#212D40',
    fontSize: 14,
    fontFamily: 'roboto-bold',
    margin: 0,
    marginTop: 12,
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  iconBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative'
  },
  row: {
    alignItems: 'flex-start',
    display: 'flex',
  },
  tip: {
    color: '#017aef', 
    fontSize: 30, 
    marginTop: 11,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  active: {
    background: '#FFCE7B',
  },
  overlayPanel: {
    fontFamily: 'roboto-regular',
    fontSize: 12,
    padding: 15,
    background: '#F0F0F0',
    color: '#212D40',
    minWidth: 400,
    lineHeight: '15px',
    position: 'absolute',
    bottom: -120,
    zIndex: 1,
    boxShadow: "0 3px 4px rgba(0, 0, 0, 0.5)",
  },
  mailWord: {
    color: '#017AEF',
    textDecoration: 'none'
  },
  infoIcon: {
    width: 30,
    height: 30,
    marginTop: 11,
    cursor: 'pointer'
  },
}));

const MultiWaysInvite = () => {

  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const { userMetrics, hubLists } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { moderatedInviteWay, modLastActivePage } = userMetrics;
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  const [linkOverlay, setLinkOverlay] = useState(false);
  const [calendarOverlay, setCalendarOverlay] = useState(false);
  const [hubOverlay, setHubOverlay] = useState(false);

  useEffect(() => {
    if (history.location.hash !== '#mod3') {
      UtilService.addHashTag(history, location.pathname, 'mod3');
    }
  }, []);

  const onCheckInvite = (inviteWay: string) => {
    if (inviteWay === 'hub') {
      const request = loginUserData.department_id ? {department_id: Number(loginUserData.department_id)} : {};
      dispatch(getHubs(apolloClient.client, request));
      dispatch(updateUserMetrics('using_hub_connectivity', true));
    }
    dispatch(updateUserMetrics('moderatedInviteWay', inviteWay));
    dispatch(moveNextPage(2));
    (modLastActivePage < 2) && dispatch(updateUserMetrics('modLastActivePage', 2));
  };

  return (
    <div>
      <p className="creator-title mt-65">
        Now let’s add some brains!
      </p>
      <p className='creator-main-title'>
        Multiple ways to invite participants
      </p>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img src='/assets/icons/experiencebuilder/two-ways.svg' alt="{}" />
        </div>
        <div className={classes.row} style={{ display: 'flex', flexDirection: 'column', width: '325px', marginTop: 80 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <div className={classes.iconBox}>
              <div
                className={clsx(classes.square, moderatedInviteWay === 'link' && classes.active)}
                onClick={() => onCheckInvite('link')}
              >
                <img src={'/assets/icons/experiencebuilder/link.svg'} className={classes.icon} alt="{img}" />
              </div>
              <p className={classes.tinyTitle}>By sending a link</p>
              <img
                className={classes.infoIcon}
                alt="Info Icon"
                src={'/assets/icons/info.svg'}
                onMouseEnter={() => setLinkOverlay(true)}
                onMouseOut={() => setLinkOverlay(false)}
              />
              {linkOverlay && (
                <div className={classes.overlayPanel}>
                  Let us walk you through creating the event and adding participants. At the end, we can send out the instructions for you, or you can use a public link to share however you like.<br /><br />
                  **This path is best if you want us to help you through the whole process.
                </div>
              )}
            </div>

            <div className={classes.iconBox}>
              <div
                className={clsx(classes.square, moderatedInviteWay === 'calendar' && classes.active)}
                onClick={() => onCheckInvite('calendar')}
              >
                <img src={'/assets/icons/experiencebuilder/calendar.svg'} className={classes.icon} alt="{img}" />
              </div>
              <p className={classes.tinyTitle}>Use your calendar app</p>
              <img
                className={classes.infoIcon}
                alt="Info Icon"
                src={'/assets/icons/info.svg'}
                onMouseEnter={() => setCalendarOverlay(true)}
                onMouseOut={() => setCalendarOverlay(false)}
              />
              {calendarOverlay && (
                <div className={classes.overlayPanel} style={{ left: -180 }}>
                  You can use your favorite calendar app to set up the event and invite participants. Don’t worry, we’ll walk you through the magic of how to make that happen.<br /><br />
                  **This path is best for advanced users who prefer using their calendar app to send invites.
                </div>
              )}
            </div>
          </div>
          {(hubLists.length > 0) && (
            <div className={classes.iconBox} style={{ marginTop: 50 }}>
              <div
                className={clsx(classes.square, moderatedInviteWay === 'hub' && classes.active)}
                onClick={() => onCheckInvite('hub')}
              >
                <img src={'/assets/icons/experiencebuilder/connectivity-hub.svg'} className={classes.icon} alt="{img}" />
              </div>
              <p className={classes.tinyTitle}>Use Connectivity Hub</p>
              <img
                className={classes.infoIcon}
                alt="Info Icon"
                src={'/assets/icons/info.svg'}
                onMouseEnter={() => setHubOverlay(true)}
                onMouseOut={() => setHubOverlay(false)}
              />
              {hubOverlay && (
                <div className={classes.overlayPanel}>
                  Hubs allow multiple participants to anonymously connect fitness bands to a single centralized piece of hardware for live experiences. If the Immersion team has already provisioned and sent you a Hub, select this option.<br /><br />
                  For more information contact <span className={classes.mailWord}>success@getimmersion.com</span>
                </div>
              )}
            </div>
          )}
        </div>

      </div>
    </div>
  )
};

export default MultiWaysInvite;